import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/gdpr-profile/history/')({
  component: () => null,
});
